import actions from './actions';
import { DigitalTrapThresholdsState } from './models';

const initialState: DigitalTrapThresholdsState = {
  list: [],
  isLoading: false,
  isSaving: false,
  modalVisible: false,
  selected: null
};

const digitalTrapThresholdsReducer = (state = initialState, action): DigitalTrapThresholdsState => {
  switch (action.type) {
    case actions.LOAD_THRESHOLDS:
      return { ...state, isLoading: true };

    case actions.LOAD_THRESHOLDS_SUCCESS:
      return { ...state, isLoading: false, list: action.payload };

    case actions.LOAD_THRESHOLDS_FAILURE:
      return { ...state, isLoading: false };

    case actions.SAVE_THRESHOLD:
      return { ...state, isSaving: true };

    case actions.SAVE_THRESHOLD_SUCCESS:
      return { ...state, isSaving: false, modalVisible: false, selected: null };

    case actions.SAVE_THRESHOLD_FAILURE:
      return { ...state, isSaving: false };

    case actions.TOGGLE_THRESHOLD_MODAL:
      return { ...state, modalVisible: !state.modalVisible, selected: action.payload };

    default:
      return state;
  }
};

export default digitalTrapThresholdsReducer;
